"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOrEditAutomationModal = exports.emptyAutomation = void 0;
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var react_1 = __importStar(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var styles = __importStar(require("./CreateOrEditAutomationModal.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var TwoPanelSettingsModal_1 = require("../TwoPanelSettingsModal");
var lodash_1 = require("lodash");
var AutomationsApiService_1 = require("Library/AutomationLibrary/AutomationsApiService");
var AutomationsForm_1 = require("./AutomationsForm");
var icons = __importStar(require("@qwilr/kaleidoscope/icons"));
var hasValidAutomationSelections_1 = require("Library/AutomationLibrary/hasValidAutomationSelections");
var AutomationAssignment_1 = require("Library/AutomationLibrary/AutomationAssignment");
var mapAutomationError_1 = require("Library/AutomationLibrary/mapAutomationError");
var IntegrationSelection_1 = require("./IntegrationSelection");
var inversify_react_1 = require("inversify-react");
var EnableIntegrationAlert_1 = require("./EnableIntegrationAlert");
var useAutomationsTelemetry_1 = require("Library/AutomationLibrary/hooks/useAutomationsTelemetry");
exports.emptyAutomation = {
    name: "",
    enabled: true,
    description: "",
    triggerId: "",
    actions: [],
    integration: "",
    associations: [],
    isGloballyAssigned: false,
};
var isCreatedAutomation = function (automation) { return "id" in automation; };
function CreateOrEditAutomationModal(_a) {
    var _this = this;
    var createCallback = _a.createCallback, updateCallback = _a.updateCallback, closeModal = _a.closeModal, automation = _a.automation, automationsMetadata = _a.automationsMetadata, notifyUser = _a.notifyUser;
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var modalService = (0, inversify_react_1.useInjection)("modal");
    var telemetry = (0, useAutomationsTelemetry_1.useAutomationsTelemetry)();
    var isCreateNew = !automation;
    var _b = __read((0, react_1.useState)(undefined), 2), apiError = _b[0], setApiError = _b[1];
    var integrationMetadata = automationsMetadata.data[isCreateNew
        ? 0
        : automationsMetadata.data.map(function (automation) { return automation.integrationName; }).indexOf(automation.integration)];
    (0, tiny_invariant_1.default)(integrationMetadata, "Integration not found");
    var _c = __read((0, react_1.useState)(isCreateNew
        ? __assign(__assign({}, exports.emptyAutomation), { integration: integrationMetadata === null || integrationMetadata === void 0 ? void 0 : integrationMetadata.integrationName }) : function () { return (0, lodash_1.cloneDeep)(automation); }), 2), currentAutomation = _c[0], setCurrentAutomation = _c[1];
    var defaultObjectType;
    if ((integrationMetadata === null || integrationMetadata === void 0 ? void 0 : integrationMetadata.supportedObjects.length) > 0) {
        defaultObjectType = integrationMetadata.supportedObjects[0] || undefined;
        (0, tiny_invariant_1.default)(defaultObjectType, "Supported object does not exist");
    }
    var _d = __read((0, react_1.useState)({
        integrationName: integrationMetadata.integrationName,
        displayName: integrationMetadata.displayName,
        objectType: defaultObjectType === null || defaultObjectType === void 0 ? void 0 : defaultObjectType.name,
        objectDisplayName: defaultObjectType === null || defaultObjectType === void 0 ? void 0 : defaultObjectType.pluralName,
        enabled: integrationMetadata.enabled,
        canBeGloballyAssigned: integrationMetadata.canBeGloballyAssigned,
    }), 2), selectedTarget = _d[0], setSelectedTarget = _d[1];
    var _e = (0, AutomationsApiService_1.useTriggersAndActions)({
        integrationName: selectedTarget.integrationName,
        objectType: selectedTarget.objectType,
        shouldFetch: selectedTarget.enabled,
    }), triggersAndActions = _e.triggersAndActions, refreshTriggersAndActions = _e.refreshTriggersAndActions;
    var integrationChangeHandler = function (target) {
        setSelectedTarget(target);
        setCurrentAutomation(__assign(__assign({}, currentAutomation), { integration: target.integrationName, triggerId: "", actions: [], associations: [], isGloballyAssigned: false }));
        refreshTriggersAndActions();
        automationsMetadata.mutate();
    };
    var onAutomationChange = function (updatedAutomation) {
        setCurrentAutomation(updatedAutomation);
        setApiError(undefined);
    };
    var handleClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var okToApply, hasAssignments, e_1, mappedError, e_2, mappedError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    okToApply = true;
                    hasAssignments = currentAutomation.associations.length || currentAutomation.isGloballyAssigned;
                    if (!!hasAssignments) return [3, 2];
                    return [4, modalService.showConfirmModal({
                            title: "Missing something?",
                            explainer: "We noticed you haven't assigned your automation yet so it can't run.",
                            confirmLabel: isCreatedAutomation(currentAutomation) ? "Apply" : "Create",
                            cancelLabel: "Go back",
                            isEscapable: true,
                        })];
                case 1:
                    okToApply = _a.sent();
                    telemetry.trackAssignmentSkipped(okToApply);
                    _a.label = 2;
                case 2:
                    if (!okToApply) return [3, 11];
                    if (!!isCreatedAutomation(currentAutomation)) return [3, 7];
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4, createCallback(currentAutomation)];
                case 4:
                    _a.sent();
                    notifyUser.success(react_1.default.createElement(react_1.default.Fragment, null, "Automation successfully created!"));
                    return [3, 6];
                case 5:
                    e_1 = _a.sent();
                    mappedError = (0, mapAutomationError_1.mapAutomationError)(e_1);
                    setApiError(mappedError);
                    return [2, false];
                case 6: return [3, 10];
                case 7:
                    _a.trys.push([7, 9, , 10]);
                    return [4, updateCallback(currentAutomation)];
                case 8:
                    _a.sent();
                    notifyUser.success(react_1.default.createElement(react_1.default.Fragment, null, "Automation settings have been updated!"));
                    return [3, 10];
                case 9:
                    e_2 = _a.sent();
                    mappedError = (0, mapAutomationError_1.mapAutomationError)(e_2);
                    setApiError(mappedError);
                    return [2, false];
                case 10: return [2, true];
                case 11: return [2];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: styles.modalWrapper },
        react_1.default.createElement(TwoPanelSettingsModal_1.TwoPanelSettingsModal, { itemNoun: "automation", isNew: isCreateNew || !isCreatedAutomation(currentAutomation), onApply: handleClick, onClose: closeModal, hasUnsavedChanges: function () { return !(0, isEqual_1.default)(currentAutomation, isCreateNew ? exports.emptyAutomation : automation); }, hasValidInputs: function () {
                return triggersAndActions ? (0, hasValidAutomationSelections_1.hasValidAutomationSelections)(currentAutomation, triggersAndActions) : false;
            }, headerInfo: !selectedTarget.enabled ? (react_1.default.createElement(EnableIntegrationAlert_1.EnableIntegrationAlert, { selectedTarget: selectedTarget, apiBaseUrl: apiBaseUrl, integrationChangeHandler: integrationChangeHandler })) : apiError ? (react_1.default.createElement(kaleidoscope_1.Text, { size: "s", className: styles.errorText }, "There was an error saving your automation.")) : undefined, left: react_1.default.createElement(LeftPanel, { selectedTarget: selectedTarget, automation: currentAutomation, onAutomationChange: onAutomationChange }), right: react_1.default.createElement(RightPanel, { selectedTarget: selectedTarget, automation: currentAutomation, onAutomationChange: onAutomationChange, triggersAndActions: triggersAndActions, error: apiError, automationsMetadata: automationsMetadata.data, integrationChangeHandler: integrationChangeHandler }) })));
}
exports.CreateOrEditAutomationModal = CreateOrEditAutomationModal;
var LeftPanel = function (_a) {
    var selectedTarget = _a.selectedTarget, automation = _a.automation, onAutomationChange = _a.onAutomationChange;
    var Icon = icons[(0, lodash_1.capitalize)(selectedTarget.integrationName)] || icons.Tokens;
    return (react_1.default.createElement("div", { className: styles.leftPanelWrapper },
        react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Name", placeholder: "Name this automation", value: automation.name, onChange: function (value) { return onAutomationChange(__assign(__assign({}, automation), { name: value })); }, maxLength: 100 }),
        react_1.default.createElement(kaleidoscope_1.TextInput, { multiline: true, label: "Description", value: automation.description, onChange: function (value) { return onAutomationChange(__assign(__assign({}, automation), { description: value })); }, maxLength: 250 }),
        react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "s" },
            react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/category/836-automations" }, "Learn more"),
            " about Qwilr automations.")));
};
var RightPanel = function (_a) {
    var selectedTarget = _a.selectedTarget, automation = _a.automation, onAutomationChange = _a.onAutomationChange, triggersAndActions = _a.triggersAndActions, error = _a.error, automationsMetadata = _a.automationsMetadata, integrationChangeHandler = _a.integrationChangeHandler;
    return (react_1.default.createElement("div", { className: styles.rightPanelWrapper },
        react_1.default.createElement(IntegrationSelection_1.IntegrationSelection, { selectedTarget: selectedTarget, automationsMetadata: automationsMetadata, onIntegrationSelection: integrationChangeHandler }),
        triggersAndActions || !selectedTarget.enabled ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(AutomationsForm_1.AutomationsForm, { triggersAndActions: triggersAndActions || { actions: [], triggers: [] }, integrationTarget: selectedTarget, currentAutomation: automation, onAutomationChange: onAutomationChange, disabled: !selectedTarget.enabled }),
            react_1.default.createElement(AutomationAssignment_1.AutomationAssignment, { associations: automation.associations, onAssociationsChange: function (newAssociations) {
                    onAutomationChange(__assign(__assign({}, automation), { associations: newAssociations }));
                }, onIsGloballyAssignedChange: function (isGloballyAssigned, associations) {
                    onAutomationChange(__assign(__assign({}, automation), { associations: associations, isGloballyAssigned: isGloballyAssigned }));
                }, supportedTemplates: selectedTarget.objectType
                    ? [
                        {
                            object: selectedTarget.objectType,
                            crm: selectedTarget.integrationName,
                        },
                    ]
                    : [], errorMessage: (error === null || error === void 0 ? void 0 : error.field) === "associations" ? error.message : undefined, errorIds: (error === null || error === void 0 ? void 0 : error.field) === "associations" ? error.templateIds : undefined, canBeGloballyAssigned: selectedTarget.canBeGloballyAssigned, initialIsGloballyAssigned: automation.isGloballyAssigned }))) : (react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true }))));
};
